import { render, staticRenderFns } from "./ylfw_add.vue?vue&type=template&id=7ecc4b00&scoped=true&"
import script from "./ylfw_add.vue?vue&type=script&lang=js&"
export * from "./ylfw_add.vue?vue&type=script&lang=js&"
import style0 from "./ylfw_add.vue?vue&type=style&index=0&id=7ecc4b00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecc4b00",
  null
  
)

export default component.exports